import { render, staticRenderFns } from "./PokemonPagination.vue?vue&type=template&id=657ad314&scoped=true&"
import script from "./PokemonPagination.vue?vue&type=script&lang=js&"
export * from "./PokemonPagination.vue?vue&type=script&lang=js&"
import style0 from "./PokemonPagination.vue?vue&type=style&index=0&id=657ad314&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657ad314",
  null
  
)

export default component.exports